//UI reducer types
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const LOADING_UI_SUCCESS = "LOADING_UI_SUCCESS";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_THEME_MODE = "SET_THEME_MODE";
